import { ActionListDivider } from "../ActionList/ActionListDivider";
import { CollapsibleListItemContext, CollapsibleListItemRenderMode } from "../CollapsibleList/CollapsibleList";
import { ReactElement, useContext } from "react";
import styles from "./ActionBarDivider.module.less";

export const ActionBarDivider = (): ReactElement => {
	const { renderMode } = useContext(CollapsibleListItemContext);

	if (renderMode === CollapsibleListItemRenderMode.Collapsed) {
		return (
			<ActionListDivider />
		);
	}

	return (
		<div className={styles.root}>
			<div className={styles.divider} />
		</div>
	);
};
ActionBarDivider.displayName = "ActionBarDivider";
